<template>
    <CModal
        :title="titleComponent"
        :show.sync="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formActiveUser" @submit="formSubmit($event, 'activeUser')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'activeUser',
                    fieldName:'email'
                })"
                :value.sync="$v.forms.activeUser.email.$model"
                :label="$t('email')"
                :disabled="true"
            />
            <CInput
                :isValid="checkIfFormValid({
                    formName:'activeUser',
                    fieldName:'code'
                })"
                :value.sync="$v.forms.activeUser.code.$model"
                :label="$t('code')"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.activeUser._loading"
            >
                <span>{{ $t('activate_user') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.activeUser._loading">
                {{ $t("activate_user") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators"
import PhoneNumberInput from '~/components/PhoneNumberInput.vue';
import ButtonLoading from '~/components/ButtonLoading.vue';
export default {
    name: "ActiveUserModal",
    mixins: [formMixin, validationMixin],
    components: {
        PhoneNumberInput,
        ButtonLoading
    },
    props:{
        title: String,
        show: Boolean,
        color: String,
        size: String,
        email: String|null,
    },

    data(){
        return {
            titleComponent: null,
            showComponent:false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms:{
                activeUser:{
                    email: null,
                    code: null,
                    _loading: false,
                },
            }
        }
    },

    validations:{
        forms:{
            activeUser:{
                email:{
                    required
                },
                code:{
                    required
                }
                
            }
        }
    },

    watch:{
        title(){
            this.titleComponent = this.title;
        },
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('activeUser');
                this.$v.$reset();
            }
        },
        color(){
            this.colorComponent = this.color;
        },
        size(){
            this.sizeComponent = this.size;
        },
        email(){
            this.forms.activeUser.email = this.email;
        },

        showComponent(){
            this.$emit('update:show',this.showComponent);
        },
    },

    methods:{
        closeModal(){
            this.showComponent = false;
        },


        async formSubmit(e, formName){
            e.preventDefault();
            let response = await this.sendForm({ 
                formName , 
                url: '/account.api/users/active/user'
            });
            this.showComponent = false;
            this.$emit('submit',response);
        },

        executeSubmitForm(){
            this.$refs.formActiveUser.requestSubmit();
        }
    },

    mounted(){
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
        this.forms.activeUser.email = this.email;
    },
};
</script>

<style>
</style>